"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dynatrace = void 0;
const library_1 = require("../../core/library");
const loader_1 = require("./loader");
class Dynatrace extends library_1.Library {
    constructor(dynatraceURL) {
        super('Dynatrace', new loader_1.DynatraceLoader(dynatraceURL));
    }
}
exports.Dynatrace = Dynatrace;
//# sourceMappingURL=index.js.map